import React, { Component } from 'react';
import './Home.css';
import Navbar from './Navbar';
import logo from '../gerenciamento-de-pessoas.jpg';

class Gerenciar extends Component {

	render() {
		return (
	  		<div>

	    		<Navbar />
	    		<img className="tela" src={logo} alt="logo"></img>
	  		</div>
		);
	}
}

export default Gerenciar;


// WEBPACK FOOTER //
// ./src/components/Gerenciar.js